
//Types
import { 
    BUSCAR_TDOCS,
    MODIFICAR_FILTROS,
    CARGANDO_CONTROL,
    ACTUALIZAR_TDOC,
    AGREGAR_TDOC,
    APLICAR_FILTROS,
    INICIALIZAR_FILTROS,
    MODIFICAR_FILTROS_ESTADOS,
    MODIFICAR_FILTROS_RANGO,
    INICIAR_FILTROS,
    INICIAR_FILTROS_DASHBOARDODT,
    SET_INFO_DASHBOARDODT,
    SET_TDOCS,
    SET_TDOCS_REPORTE,
    DELETE_TDOC,
    MERGE_TDOCS
    
} from "./controlActions";

const controlReducer = (state, action) => {

    switch(action.type){
        
        case INICIAR_FILTROS: {
            return {
                ...state,
                filtrosEstado: action.payload.filtrosEstado,
                filtrosRango: action.payload.filtrosRango,
                listTDoc: action.payload.tDocs,
                filtrosEstadoPredeterminado: action.payload.filtrosEstado,
                cargando: false
            }
        }
        
        case INICIAR_FILTROS_DASHBOARDODT: {
            return {
                ...state,
                cargando: false,
                filtrosRango: action.payload.filtrosRango,
                filtrosEstado: action.payload.filtrosEstado,
                filtrosEstadoPredeterminado: action.payload.filtrosEstado,
            }
        }
        
        case SET_INFO_DASHBOARDODT: {
            return {
                ...state,
                cargando: false,
                infoTDocs: action.payload.infoTDocs,
            }
        }

        case MODIFICAR_FILTROS: {
            return {
                ...state,
                filtrosRango: action.payload.filtrosRango,
                filtrosEstado: action.payload.filtrosEstado,
            }
        }

        case MODIFICAR_FILTROS_RANGO: {
            return {
                ...state,
                filtrosRango: action.payload.filtrosRango,
                cargando:true
                // listTDoc: action.payload.listaRequerimientos,
                // cargando: false
            }
        }

        case MODIFICAR_FILTROS_ESTADOS: {
            return {
                ...state,
                filtrosEstado: action.payload,
                cargando: false
            }
        }

        case SET_TDOCS: {
            return {
                ...state,
                listTDoc: action.payload.cabeceraReqs,
                cargando: false
            }
        }
        
        case MERGE_TDOCS: {
            return {
                ...state,
                listTDoc: [...state.listTDoc, ...action.payload.tDocsToMerge],
                cargando: false
            }
        }
        
        case SET_TDOCS_REPORTE: {
            return {
                ...state,
                listTDocReporte: action.payload.listaRequerimientos,
                cargando: false
            }
        }

        case AGREGAR_TDOC: { 
            return {
                ...state, 
                listTDoc: (state.listTDoc !== null) ? [action.payload , ...state.listTDoc ] : []
            }
        }
        

        case ACTUALIZAR_TDOC: {
            return {
                ...state,
                listTDoc: state.listTDoc.map((t) => t._id === action.payload._id ? action.payload : t)
            }
        }
        
        case DELETE_TDOC: {
            return {
                ...state,
                listTDoc: state.listTDoc.filter(t => t._id != action.payload)
            }
        }

        
        //xx

        default:
            return state;
    }
}

export default controlReducer;